import { jsx as _jsx } from "react/jsx-runtime";
import AssetDetail from './AssetDetail.jsx';
export default function () {
    return (_jsx("div", { style: { padding: 20, overflow: 'hidden', display: 'flex', flexDirection: 'column' }, children: _jsx(AssetDetail, {}) }));
}
